window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.form-dropzone').length) {
    import('./_dropzone.js').then((module) => {
      module.Init();
    });
  }
});

export default {};
